import boomLogo from "@/assets/boom-logo.png.asset.json";
import collinsLogo from "@/assets/collins-logo.png.asset.json";
import zimmermanLogo from "@/assets/zimmerman-logo.png.asset.json";
import pharmacyCbsLogo from "@/assets/pharmacy-cbs-logo.png.asset.json";
import pioneerLogo from "@/assets/pioneer-logo.png.asset.json";
import raceAiLogo from "@/assets/race-ai-logo.png.asset.json";
import acreLogo from "@/assets/acre-logo.png.asset.json";
import successFitnessLogo from "@/assets/success-fitness-logo.png.asset.json";

const LOGOS = [
  { name: "Boom Marketing", src: boomLogo.url, scale: "md:scale-110" },
  { name: "Collins Transportation", src: collinsLogo.url },
  { name: "Zimmerman Commercial Construction", src: zimmermanLogo.url, scale: "md:scale-110" },
  { name: "Pharmacy CBS", src: pharmacyCbsLogo.url },
  { name: "Pioneer Management Consulting", src: pioneerLogo.url, scale: "md:scale-110" },
  { name: "Race.AI", src: raceAiLogo.url },
  { name: "Acre", src: acreLogo.url, scale: "md:scale-115" },
  { name: "Success Fitness & Training", src: successFitnessLogo.url, scale: "md:scale-115" },
];


export function LogoStrip() {
  return (
    <section className="border-b border-border/30 bg-background/50 px-5 py-8 sm:px-6 sm:py-10 md:px-8 md:py-12 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-8">
          Trusted by teams like these
        </p>
         <div className="grid grid-cols-2 items-center gap-x-5 gap-y-6 sm:grid-cols-4 sm:gap-x-6 sm:gap-y-8 md:gap-x-10 lg:grid-cols-8 lg:gap-x-8">
          {LOGOS.map((logo) => {
            const scale = logo.scale ?? "";
            return (
              <div key={logo.name} className="flex items-center justify-center px-2 transition-transform duration-300 h-12 md:h-14 lg:h-16">
                <img
                  src={logo.src}
                  alt={logo.name}
                  className={`h-full w-auto max-w-full object-contain opacity-80 hover:opacity-100 transition-all duration-300 ${scale}`}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
